export const SET_AUTH = 'auth/SET_AUTH'
export const CLEAR_AUTH = 'auth/CLEAR_AUTH'
export const UPDATE_ME = 'auth/UPDATE_ME'
export const MERGE_ME = 'auth/MERGE_ME'
export const TOKEN_REFRESH = 'auth/TOKEN_REFRESH'

export const FOLLOW_USER = 'auth/FOLLOW_USER'
export const UN_FOLLOW_USER = 'auth/UN_FOLLOW_USER'
